import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Login } from "../services/LoginService";
import { setAuth } from "../Redux/authSlice";
import imgLogin from "../assets/imgLogin1.png";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (auth?.isAuthenticated && auth?.token) {
      navigate("/EspaceClient", { state: { message: "Connexion réussie ✅" } });
    } else {
      const savedEmail = localStorage.getItem("email");
      const savedPassword = localStorage.getItem("password");
      if (savedEmail) setEmail(savedEmail);
      if (savedPassword) setPassword(savedPassword);
    }
  }, [auth, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");

    if (!email || !password) {
      setLoading(false);
      setErrorMessage("Veuillez remplir tous les champs.");
      return;
    }

    try {
      const response = await Login(email, password);

      if (response.success) {
        dispatch(setAuth({ token: response.token, email, password }));
        if (!rememberMe) {
          localStorage.removeItem("email");
          localStorage.removeItem("password");
        }
        setLoading(false);


      }
      else {
        setLoading(false);
        setErrorMessage(response.message || "Échec de la connexion.");
      }
    } catch (error) {
      setLoading(false);
      setErrorMessage("Erreur inattendue.");
    }
  };

  return (
    <div className="flex flex-col lg:flex-row w-screen min-h-screen max-h-screen overflow-hidden">
      {/* IMAGE LG (gauche sur desktop) */}
      <div className="hidden lg:block lg:w-1/2 relative h-screen">
        <div
          className="absolute inset-0 bg-center bg-cover"
          style={{ backgroundImage: `url(${imgLogin})` }}
        />
        <div className="absolute inset-0 bg-black opacity-40" />
      </div>

      {/* FORMULAIRE */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-4 py-10 bg-color2">
        <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-lg">
          {/* Titre */}
          <h1 className="text-4xl font-bold text-blue-800">Bienvenue</h1>
          <p className="text-sm lg:text-lg lg:font-semibold text-blue-700 mt-2">
            Connectez-vous pour gérer votre profil et vos activités.
          </p>

          {/* Erreur */}
          {errorMessage && (
            <div className="mt-4 bg-red-100 text-red-600 text-sm p-2 rounded">
              {errorMessage}
            </div>
          )}

          {/* Email */}
          <div className="mt-5 flex flex-col gap-1">
            <label htmlFor="email" className="text-sm lg:text-base lg:font-semibold text-blue-700">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="votre@email.com"
              className="w-full px-2 py-2 text-black text-sm rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
            />
          </div>

          {/* Mot de passe */}
          <div className="mt-4 flex flex-col gap-1">
            <label htmlFor="password" className="text-sm lg:text-base lg:font-semibold  text-blue-700">
              Mot de passe
            </label>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="********"
              className="w-full px-2 py-2 text-black text-sm rounded-lg border-color3 focus:border-color1 outline-none transition placeholder:text-blue-600 placeholder:font-semibold"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="text-xs text-color3 self-end mt-1"
            >
              {showPassword ? "Masquer" : "Afficher"} le mot de passe
            </button>
          </div>

          {/* Options */}
          <div className="mt-4 flex items-center justify-between text-sm">
            <label className="flex items-center gap-2 text-blue-700">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
                className="accent-color1"
              />
              Se souvenir de moi
            </label>
            <Link to="/Forgetpwd" className="text-blue-800 hover:underline">
              Mot de passe oublié ?
            </Link>
          </div>

          {/* Boutons */}
          <div className="mt-6 flex flex-col gap-3">
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="bg-color1 text-white font-semibold py-2 px-4 rounded-lg hover:bg-color1/90 transition disabled:opacity-50"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </button>
            <Link
              to="/newcompte"
              className="border border-color3 text-color3 text-center font-semibold py-2 px-4 rounded-lg hover:bg-color3 hover:text-white transition"
            >
              Créer un compte
            </Link>
          </div>
        </div>
      </div>
    </div>

  );

};

export default LoginPage;
